import { Card, Space, Button } from 'antd';
import { useEffect, useState } from 'react';
import {
  LoadingOutlined
} from '@ant-design/icons';
import BreadcrumbList from '../../../Shared/Components/Breadcrumb/Breadcrumb';
import './MedicaidMeetings.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ServiceUtils } from '../../../Shared/Utils/ServiceUtils';
import { alertService } from '../../../Shared/Utils/ToasterUtils';

const MedicaidMeetings = () => {
  const [meetingDetails, setMeetingDetails] = useState([]);
  const {id} = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const filters = location?.state?.filters;

  useEffect(() => {
      fetchMeetingDetails();
  },[])

    const fetchMeetingDetails = () => {
    let payload = {
      id: id,
      therapyClasses: filters?.therapyClass,
      drugClasses: filters?.drugClasses
    };

    ServiceUtils.postRequest("medicaidMeetingDetails", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let medMeetingsData = JSON.parse(
            JSON.stringify(response?.data?.data)
          );
          setMeetingDetails(medMeetingsData);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

    const columns = [
    {
      label: "Medicaid",
      link: "/home/medicaid",
    },
    {
      label: "Meeting Details",
      link: "",
    },
  ];
    return (
      <div className="medicaidMeetings">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>
        <Card>
          <div className="meeting-wrapper">
            {meetingDetails?.map((meeting, meetingIndex) => (
              <div key={meetingIndex} className="meeting-card">
                <h2>
                  {meeting.meeting_name}{" "}
                  <span>
                    ({meeting.state} | {meeting.governance})
                  </span>
                </h2>
                {meeting.agendaLink && (
                  <Button
                    type="primary"
                    href={meeting.agendaLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Agenda
                  </Button>
                )}

                {meeting.meetingDetails?.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="section">
                    {section.content?.length > 0 && (
                      <>
                        <h3>{section.header}</h3>

                        <ul>
                          {section.content.map((contentItem, contentIndex) => (
                            <li key={contentIndex}>{contentItem}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Card>
      </div>
    );
}

export default MedicaidMeetings;